import { render, staticRenderFns } from "./PreviewPanel.vue?vue&type=template&id=0328e116&"
import script from "./PreviewPanel.vue?vue&type=script&lang=js&"
export * from "./PreviewPanel.vue?vue&type=script&lang=js&"
import style0 from "./PreviewPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports